import { Component, OnInit } from '@angular/core';
import {MatSnackBar} from '@angular/material/snack-bar';
import { NotificationService } from '../notification.service';
import {MatDialog} from '@angular/material/dialog';
import { AlertComponent } from '../alert/alert.component';
import { StorageService} from '../storage-service.service';
import { DataShareService } from '../cart.service';

@Component({
  selector: 'app-favorites',
  templateUrl: './favorites.component.html',
  styleUrls: ['./favorites.component.scss']
})
export class FavoritesComponent implements OnInit {
  favProduct = [];
  favLength;
  totalAmount : number = 0;
  cartProduct = [];

  constructor(private notifyService : NotificationService, public dialog: MatDialog,
    private dataShareService: DataShareService, private storageService: StorageService) { }

  ngOnInit(): void {
    this.getFavoriteProduct();
    this.favLength = this.favProduct.length;
    this.calculateTotalAmount();
    this.getCartProduct();
  }

  calculateTotalAmount() {
    for (let i = 0; i < this.favProduct.length; i++) {
      this.totalAmount += this.favProduct[i].price;
    }
  }

  getCartProduct() {
    this.cartProduct = JSON.parse(localStorage.getItem('cartProduct'));
    console.log(this.cartProduct);
  }

  getFavoriteProduct() {
    this.favProduct = JSON.parse(localStorage.getItem('favProduct'));
    console.log(this.favProduct);
  }

  checkCart(product) {
    let findProduct = this.favProduct.some(item => item.id == product.id)
    if(findProduct) {
      return 'Add to Cart';
    } else {
      return 'Remove from Cart'
    }
  }

  showToasterSuccess(message){
    this.notifyService.openSnackBar(message);
  }

  getCartProducts() {
    this.favProduct = JSON.parse(localStorage.getItem('cartProduct'));
  }

  removeProduct(cartItem){
    const dialogRef = this.dialog.open(AlertComponent);

    dialogRef.afterClosed().subscribe(result => {
      console.log(`Dialog result: ${result}`);
      if(result){
        this.checkCartProduct(cartItem);
      } else {
        return;
      }
    });
  }

  checkCartProduct(product) {
    let findProduct = this.favProduct.some(item => item.id == product.id)
    if(!findProduct) {
      this.favProduct.push(product);
      this.showToasterSuccess('Product added in your cart list!');
    } else {
      let removeProduct = this.favProduct.filter(item => item.id !== product.id);
      this.favProduct = removeProduct;
      this.showToasterSuccess('Product removed in your cart list!');
    }
    this.calculateTotalAmount();
    this.storageService.setItem('favProduct',JSON.stringify(this.favProduct));
  }

  addCart(product) {
    let findProduct = this.cartProduct.some(item => item.id == product.id)
    if(!findProduct) {
      product.count = 1;
      this.cartProduct.push(product);
      this.showToasterSuccess('Product added in your cart list!');
    } else {
      let removeProduct = this.cartProduct.filter(item => item.id !== product.id);
      this.cartProduct = removeProduct;
      this.showToasterSuccess('Product removed in your cart list!');
    }
    this.calculateTotalAmount();
    this.storageService.setItem('cartProduct',JSON.stringify(this.cartProduct));
    this.dataShareService.sendClickEvent();
  }

}
